"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLpCfSlugGroupings = exports.detachSyntheticRecords = exports.attachSyntheticRecords = void 0;
var attach_1 = require("./attach");
Object.defineProperty(exports, "attachSyntheticRecords", { enumerable: true, get: function () { return attach_1.attachSyntheticRecords; } });
var detach_1 = require("./detach");
Object.defineProperty(exports, "detachSyntheticRecords", { enumerable: true, get: function () { return detach_1.detachSyntheticRecords; } });
var mesh_1 = require("./mesh");
Object.defineProperty(exports, "createLpCfSlugGroupings", { enumerable: true, get: function () { return mesh_1.createLpCfSlugGroupings; } });
//# sourceMappingURL=index.js.map